import { BlocksIconWifi } from 'blocks-nextjs/blocks-web-components/components/icon/icons/wifi';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconWifi = createComponent({ react: React, tagName: 'cat-icon-wifi', elementClass: BlocksIconWifi });
